import loadable, { LoadableComponent } from '@loadable/component';
import { QueryLoadingAbsolute } from 'modules/common/components/QueryLoading/QueryLoading';
import { RouteConfiguration } from 'modules/common/types/RouteConfiguration';
import { Route } from 'react-router-dom';

const PATH_INFEX = '/index';

export const IndexRoutesConfig: { [key: string]: RouteConfiguration } = {
  Index: {
    path: PATH_INFEX,
    generatePath: () => PATH_INFEX,
  },
};

const LoadableIndexContainer: LoadableComponent<any> = loadable(
  async () =>
    import('./screens').then(module => module.Home),
  {
    fallback: <QueryLoadingAbsolute />,
  },
);

export function IndexRoutes() {
  return (
    <Route
      path={IndexRoutesConfig.Index.path}
      exact={true}
      component={LoadableIndexContainer}
    />
  );
}
